import { Store, StoreState } from 'state/store/hooks';
import { POSVendor } from 'state/store/hooks/enums';

function remapStore(store: StoreState): StoreState;
function remapStore(store: Store): Store;
function remapStore(store: StoreState | Store): StoreState | Store {
  if (!store || ('hasSelection' in store && !store.hasSelection)) {
    return store;
  }

  const vendor = store.pos?.vendor;

  if (vendor && (vendor === POSVendor.QST || vendor === POSVendor.SICOM)) {
    return { ...store, pos: { ...store.pos, vendor: POSVendor.PRODUCT_NUMBER } };
  }

  return store;
}

export default remapStore;
